import { APISubscriptionData } from "@companion-core/shared/app/Interfaces/API";

export const getPhoneNumberFromSubscriptions = (subscriptions: APISubscriptionData[]) =>
  subscriptions?.find((sub) => sub.desk_phone)?.desk_phone;
